<template>
    <div>
		<!--<chat-login @logout = "logoutChat"></chat-login>
        <div v-if="loggedIn" style="margin-bottom:4px;"> 
            <div class="chat__room-item-main" v-show="showRooms[1] === chatDirectRooms[1]._id">
                <div class = "chat__room-item-data-wrap-main">
                    <div class="chat__room-item-avatar">
                        <div class="chat__room-item-avatar-img-wrap">
                            <div class="chat__room-item-avatar-img">
                                <img src = "../../assets/img/adenisov.png">
                            </div>
                        </div> 
                    </div>
                    <div class="chat__room-item-data">
                        <div class="chat__room-item-data-name">
                            <a href="#" @click="enterRoom(chatDirectRooms[1]._id)">
                                Алексей Денисов
                            </a>
                        </div>
                        <div class="chat__room-item-data-status">
                            Управляющий трейдер
                        </div>
                    </div>
                    <div class="chat__room-item-ico"
                        v-if="chatDirectRooms[1]._id !== currentRoomId">
                        <i class="mdi mdi-chevron-right"></i>
                    </div>
                    <div class="chat__room-item-data-return" v-if="chatDirectRooms[1]._id === currentRoomId" @click="returnRooms">
                        <i class="mdi mdi-chevron-left"></i>
                        <div class="chat__room-item-data-return_text">Назад</div>
                    </div>
                </div>
            </div>
            <div class="chat__room-item-main" v-show="showRooms[0] === chatDirectRooms[0]._id">
                <div class = "chat__room-item-data-wrap-main">
                    <div class="chat__room-item-avatar">
                        <div class="chat__room-item-avatar-img-wrap">
                            <div class="chat__room-item-avatar-img">
                                <img src = "../../assets/img/konsultant.jpg">
                            </div>
                        </div> 
                    </div>
                    <div class="chat__room-item-data">
                        <div class="chat__room-item-data-name">
                            <a href="#" @click="enterRoom(chatDirectRooms[0]._id)">
                                Валерия Драгун
                            </a>
                        </div>
                        <div class="chat__room-item-data-status">
                            Консультант ДУ
                        </div>
                    </div>
                    <div class="chat__room-item-ico"
                        v-if="chatDirectRooms[0]._id !== currentRoomId">
                        <i class="mdi mdi-chevron-right"></i>
                    </div>
                    <div class="chat__room-item-data-return" v-if="chatDirectRooms[0]._id === currentRoomId" @click="returnRooms">
                        <i class="mdi mdi-chevron-left"></i>
                        <div class="chat__room-item-data-return_text">Назад</div>
                    </div>
                </div>
            </div>
		</div>-->
            <div v-show="showTitle" class="chat__room-title">Команда FOREXINVEST</div>
                <nav-item  v-for="(room, index) in chatPrivateRooms" class="chat__room-item-main" :key="index + 'pr'"
                    :roomId="room.id" :avatarRoom="room.avatar" :roomTitle="room.title" :typeRoom="'private'" :typeWidget="'widget'"
                    :subtitle="room.subtitle" 
                    v-show="showDirectRoom[index] === room.id" @setRoom="enterRoom($event)" @return="returnRoom()">
                </nav-item>
            <div v-show="showTitle" class="chat__room-title">ЧАТ КОМНАТЫ</div>
                <nav-item v-for="(room, index) in chatRooms" class="chat__room-item-main" :key="index" 
                    :roomId="room.id" :avatarRoom="room.avatar" :roomTitle="room.title" :typeRoom="'public'" :typeWidget="'widget'"
                    v-show="showRooms[index] === room.id" @setRoom="enterRoom($event)" @return="returnRoom()">
                </nav-item>
        <div class = "chat__private">
            <chat-messages :extendStatus="extendStatus" v-if="activeRoom"></chat-messages>
        </div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import ChatLogin from './chat-login';
import ChatMessage from './chat-vertical-widget-messages';
import NavigatorItem from './chat-navigatorItem';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
	components: {
        "chat-login": ChatLogin,
        "chat-messages": ChatMessage,
        "scrollbar":VuePerfectScrollbar,
        "nav-item":NavigatorItem
    },
	props: {
        extendStatus:{default:false}
    },
	data() {
		return {
            chatRooms: [
                {
                    title:'ОБЩАЯ',
                    id:'GENERAL',
                    avatar:require('../../assets/img/common_room.png'),
                },
                {
                    title:'EUR/USD',
                    id:'GxPdourxnLZTn8bS3',
                    avatar: require('../../assets/img/EUR-USD.png')
                },
                {
                    title:'GBP/USD',
                    id:'SzTxmGjZ3Ls7meHip',
                    avatar: require('../../assets/img/GBP-USD.png')
                },
                {
                    title:'USD/JPY',
                    id:'quNyJDfKMLbtD2Cpd',
                    avatar: require('../../assets/img/JPY-USD.png')
                },
                {
                    title:'EUR/GBP',
                    id:'qnyBnbnoXAphn9Tyq',
                    avatar: require('../../assets/img/GBP-USD.png')
                },
                {
                    title:'USD/CAD',
                    id:'oYDdSLr8Ko4cjkAqR',
                    avatar: require('../../assets/img/USD-CAD.png')
                },
                {
                    title:'AUD/USD',
                    id:'rxJCXtWfTWM2DxSWD',
                    avatar: require('../../assets/img/AUD-USD.png')
                },
                {
                    title:'NZD/USD',
                    id:'FyHkn552jTt392MjM',
                    avatar: require('../../assets/img/NZD-USD.png')
                },
                {
                    title:'USD/CHF',
                    id:'GgaShiX8ebRZxT5j4',
                    avatar: require('../../assets/img/USD-CHF.png')
                }

            ],
            showTitle:true,
            chatPrivateRooms: [
               {
                    title:'Алексей Денисов',
                    subtitle:'Управляющий трейдер',
                    id:'aldenisov',
                    avatar:require('../../assets/img/adenisov.png'),
                },
                {
                    title:'СЛУЖБА КОМПЛАЕНС',
                    subtitle:'',
                    id:'vd_iqquantum_com',
                    avatar: require('../../assets/img/common_room.png')
                }, 
            ],
            activeRoom:false
		};
	},
	computed: {
		...mapGetters({
	        	loggedIn: 'chat/loggedIn',
                userRooms: 'chat/userRooms',
                currentRoomId: 'chat/currentRoomId',
                getLogin: 'auth/getInfoUser',
                usersInRoom:'chat/getUsersInRoom'
               }),
        userRoomsTest(){
            return this.userRooms.filter(r => r.t === 'd');
        },
		chatPairUserRooms() {
            this.userRooms.filter(r => r.t === 'c');
            let sortRooms = [];
            sortRooms = [
                {
                    title:'EUR/USD',
                    id:'GxPdourxnLZTn8bS3',
                    avatar: require('../../assets/img/EUR-USD.png')
                },
                {
                    title:'GBP/USD',
                    id:'SzTxmGjZ3Ls7meHip',
                    avatar: require('../../assets/img/GBP-USD.png')
                },
                {
                    title:'USD/JPY',
                    id:'quNyJDfKMLbtD2Cpd',
                    avatar: require('../../assets/img/JPY-USD.png')
                },
                {
                    title:'EUR/GBP',
                    id:'qnyBnbnoXAphn9Tyq',
                    avatar: require('../../assets/img/GBP-USD.png')
                },
                {
                    title:'USD/CAD',
                    id:'oYDdSLr8Ko4cjkAqR',
                    avatar: require('../../assets/img/USD-CAD.png')
                },
                {
                    title:'AUD/USD',
                    id:'rxJCXtWfTWM2DxSWD',
                    avatar: require('../../assets/img/AUD-USD.png')
                },
                {
                    title:'NZD/USD',
                    id:'FyHkn552jTt392MjM',
                    avatar: require('../../assets/img/NZD-USD.png')
                },
            ]
            return sortRooms
		},
		chatDirectRooms() {
            if(!this.userRooms.filter(r => r.t === 'd') || !this.userRooms.filter(r => r.t === 'd').length) return 0;
			return this.userRooms.filter(r => r.t === 'd');
        },
        getCountUsers() {
            if(this.usersInRoom.length === 0)
                return 
            return this.usersInRoom;
        },
        showRooms() {
            let rooms = [];
            for (let i=0; i < this.chatRooms.length; i++)
                rooms.push(this.chatRooms[i].id);
            return rooms;
        },
        showDirectRoom() {
            let rooms = [];
            for (let i=0; i < this.chatPrivateRooms.length; i++)
                rooms.push(this.chatPrivateRooms[i].id);
            return rooms;
        }
    },
    methods: {
		enterRoom(roomId) {
            for(let i=0; i < this.showRooms.length; i++) {
                if(this.showRooms[i]!== roomId)
                    this.showRooms[i] = 0
            }
            for (let i=0; i < this.showDirectRoom.length; i++) {
                if(this.showDirectRoom[i] !== roomId)
                    this.showDirectRoom[i] = 0
            }
            this.activeRoom = true;
            this.showTitle = false;
        },
        returnRoom () {
            this.$store.dispatch('chat/enterRoom', 0);
            for (let i=0; i < this.chatRooms.length; i++) {
                if(this.showRooms[i] === 0)
                    this.showRooms[i] = this.chatRooms[i].id
            }
            for (let i=0; i < this.chatPrivateRooms.length; i++) {
                if(this.showDirectRoom[i] === 0)
                    this.showDirectRoom[i] = this.chatPrivateRooms[i].id
            }
            this.activeRoom = false;
            this.showTitle = true;
        },
        setCount(idRoom, usersRoom) {
            if(usersRoom === undefined)
                return
            let cnt = 0;
            for(let i = 0; i < usersRoom.length; i++) {
                if(usersRoom[i].idRoom === idRoom)
                    cnt = usersRoom[i].cnt
            }
            return cnt
        },
        logoutChat() {
            this.$store.dispatch('chat/enterRoom', 0);
        }
	},
    watch: {
        getLogin: function() {
            this.returnRoom();
        }
    },
};
</script>

<style scoped lang="less">
.chat__room {
        &-title {
            font-family: Arimo;
            font-size: 11px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 3.64;
            letter-spacing: 0.4px;
            color: #adc7e1;
            text-transform: uppercase;
            padding-left: 12px;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        &-item {
            &-main {
                display: flex;
                background: #374b62;
                min-width: 360px;
            }
            &-ico {
                align-self: center;
                padding-right: 12px;
                i {
                    font-size: 20px;
                    color: #718da8;
                }
            }
            &-avatar {
                padding: 12px 16px 12px 12px;
                &-img {
                    &-wrap {
                        max-width: 56px;
                        max-width: 56px;
                        position: relative;
                        border-radius: 28px;
                        overflow: hidden;
                        max-height: 56px;
                    }
                }
            }
            &-data-wrap-main {
                display: flex;
                flex-grow: 1;
                border-bottom: 1px solid #324258;
                box-sizing: border-box;
            }
            &-data {
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding: 12px;
                &-name a {
                    font-family: Arimo;
                    font-size: 13px;
                    font-weight: bold;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.54;
                    letter-spacing: 0.4px;
                    text-align: left;
                    color: #ffffff;
                    text-decoration: none;
                }
                &-return {
                    display:flex;
                    align-items: center;
                    padding-right: 12px;
                    cursor: pointer;
                    i {
                        font-size: 23px;
                        color: #a1b7cc;
                    }
                    &_text {
                        font-family: Arimo;
                        font-size: 13px;
                        font-weight: normal;
                        font-style: normal;
                        font-stretch: normal;
                        line-height: 1.54;
                        letter-spacing: 0.4px;
                        text-align: left;
                        color: #a1b7cc;
                        text-decoration: none;
                        text-transform: uppercase;
                        margin-right: 40px;
                    }
                }
                &-status {
                    font-family: Arimo;
                    font-size: 13px;
                    font-weight: normal;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.54;
                    letter-spacing: 0.4px;
                    text-align: left;
                    color: #a1b7cc;
                    text-overflow: clip;
                    white-space: nowrap;
                    overflow: hidden;
                    max-width: 200px;
                }
            }
        }
}
.navWrap {
    height: calc(100vh - 140px);
}
</style>